





































































































import { editFactory } from '@/main/pages';
import { SkladMisto } from '@/modules/ciselnik/skladove/skladoveMisto';
import { apiProvider as skladApiProvider } from '@/modules/ciselnik/skladove/sklad/api';
import { NdPrijemka } from '@/modules/sklad/ndPrijemka';
import { NDPRIJEMKA_PZN } from '@/modules/sklad/ndPrijemka/constants';
import { dropdownListProvider } from '@/main/dropdownApi';
import { openList } from '@/main/router/routerPath';
// eslint-disable-next-line no-unused-vars
import { DropdownItem } from '@/main/store/@types/dropdown.d';
import { router } from '@/main/router';
import { InventuraPolozky } from '@/modules/sklad/inventuraPolozky';

import DmsPdfDialog from '#components/DmsPdfDialog.vue';

import { NAME } from './constants';
// eslint-disable-next-line no-unused-vars
import { store, SkladMistoItem } from './store/edit';
import { editMutations } from './store/types';
import { apiProvider } from './api';

export default editFactory(NAME, store).extend({
	components: {
		SkladMisto: SkladMisto.components.Select,
		DmsPdfDialog,
	},
	data() {
		return {
			visibleTiskDialog: false,
			tiskDialogUrl: '',
		};
	},
	computed: {
		mutationsMappers(): Record<string, string> {
			return {
				skladMistoOd: `${this.storeUri}/${editMutations.SKLAD_MISTO_OD_SELECT_MAPPER}`,
				skladMistoDo: `${this.storeUri}/${editMutations.SKLAD_MISTO_DO_SELECT_MAPPER}`,
			};
		},
		skladMistoItems(): SkladMistoItem[] {
			if (!this.dropdownList.SklMistoIdList.length) return [];
			return this.dropdownList.SklMistoIdList.map((skladMisto: DropdownItem) => ({
				...skladMisto,
				Selected: !!this.SklMistoIdList && this.SklMistoIdList.includes(skladMisto.Value),
			}));
		},
		labelSkladMisto(): string {
			const append = this.InvPredzpPrp ? `${this.SklMistoIdList.length} / ${this.skladMistoItems.length}` : '';
			return `${this.Localize('SKLADMISTO_ID')} ${append}`;
		},
		skladMistoEnabled(): boolean {
			return this.isCreateMode && !!this.InvPredzpPrp;
		},
		skladMistoFilter(): object {
			return {
				SkladOzn: this.SkladOzn,
			};
		},
		isPrevedena(): boolean {
			return !!this.PrevedeniDat;
		},
		disabledTiskInvListku(): boolean {
			return this.isPrevedena || this.isViewMode;
		},
		disabledTiskSeznamu(): boolean {
			return !this.isPrevedena || this.isViewMode;
		},
		disabledTiskPrehledu(): boolean {
			return !this.isPrevedena || this.isViewMode;
		},
		disabledTiskRozdilu(): boolean {
			return this.isViewMode || this.isCreateMode;
		},
		tiskFilterCmp(): object {
			return {
				InventuraId: this.InventuraId,
				InvPredzprac: this.InvPredzpPrp,
				Trideni: this.Trideni,
				InvOd: this.InvRadekOd,
				InvDo: this.InvRadekDo,
				InvSlepa: this.InvSlepaPrp,
				TiskNull: this.PrintZero,
			};
		},
	},
	methods: {
		loadedData() {
			this.PrintZero = true;
			this.InvRadekOd = this.XPocet ? 1 : 0;
			this.InvRadekDo = this.XPocet ? this.XPocet : 0;
		},
		skladMistoUpdate(newValue: boolean, id: number) {
			if (newValue) {
				if (this.SklMistoIdList.length === this.MaxSkladMisto) {
					this.showErrorAlert({ message: 'outMaxSkladMisto' });
				} else {
					this.SklMistoIdList.push(id);
				}
			} else {
				this.SklMistoIdList = this.SklMistoIdList.filter((itemId: number) => itemId !== id);
			}
		},
		oznacitSkladMisto() {
			this.SklMistoIdList = [];
			for (let i = 0; i < this.skladMistoItems.length; i++) {
				const skladMistoItem = this.skladMistoItems[i];
				if (
					(this.SkladMistoOd === null || skladMistoItem.Text >= this.SkladMistoOd)
					&& (this.SkladMistoDo === null || skladMistoItem.Text <= this.SkladMistoDo)
				) {
					if (this.SklMistoIdList.length === this.MaxSkladMisto) {
						this.showErrorAlert({ message: 'outMaxSkladMisto' });
						break;
					} else {
						this.SklMistoIdList.push(skladMistoItem.Value);
					}
				}
			}
		},
		inverzniSkladMisto() {
			if (this.skladMistoItems.length - this.SklMistoIdList.length > this.MaxSkladMisto!) {
				this.showErrorAlert({ message: 'outMaxSkladMisto' });
			} else {
				const inverzniSkladMistoIdList = [] as number[];
				this.skladMistoItems.forEach((skladMistoItem) => {
					if (!skladMistoItem.Selected) {
						inverzniSkladMistoIdList.push(skladMistoItem.Value);
					}
				});
				this.SklMistoIdList = inverzniSkladMistoIdList;
			}
		},
		zrusitSkladMisto() {
			this.SklMistoIdList = [];
		},
		async uzavritInventuru() {
			const questionResult = await this.showConfirm({
				message: await this.LocalizeChyboveHlasky('UzavrInv'),
				title: await this.LocalizeChyboveHlasky('questionTitle'),
				options: {
					confirmButtonText: this.Localize('Ano'),
					cancelButtonText: this.Localize('Ne'),
				},
			});
			if (questionResult) {
				try {
					this.startLoading();
					await apiProvider.uzavritInventuru(this.InventuraId!);
					router.back();
				} finally {
					this.endLoading();
				}
			}
		},
		async saveClick() {
			if (this.isCreateMode) {
				try {
					this.startLoading();
					const { data: existOtevrenaPrijemka } = await skladApiProvider.CheckForInventuraCreate(this.SkladOzn!);
					if (!existOtevrenaPrijemka) {
						const questionResult = await this.showConfirm({
							message: this.LocalizeChyboveHlasky('ExistOtevrenePrijemky'),
							title: this.LocalizeChyboveHlasky('questionTitle'),
							options: {
								confirmButtonText: this.Localize('Ano'),
								cancelButtonText: this.Localize('Ne'),
							},
						});
						if (questionResult) {
							await openList(NdPrijemka.name, { filter: { NdprijemPzn: NDPRIJEMKA_PZN.PRIJEM_PREVOD, SkladOzn: this.SkladOzn } });
						}
						return;
					}
					if (this.InvPredzpPrp) {
						const questionResult = await this.showConfirm({
							message: this.LocalizeChyboveHlasky('Inv_Predzpracovana'),
							title: this.LocalizeChyboveHlasky('questionTitle'),
							options: {
								confirmButtonText: this.Localize('Ano'),
								cancelButtonText: this.Localize('Ne'),
							},
						});
						if (!questionResult) {
							return;
						}
					}
				} finally {
					this.endLoading();
				}
			}
			this.save();
		},
		async polozkyClick() {
			await openList(InventuraPolozky.name, {
				filter: { InventuraId: this.InventuraId, InvRadekOd: this.InvRadekOd, InvRadekDo: this.InvRadekDo, filterBy: this.FilterBy },
				canEdit: !this.PrevedeniDat,
			});
		},
		tiskInvListku() {
			this.tiskDialogUrl = 'Sestavy/Sklad/Inventura/GetKusovnik';
			this.visibleTiskDialog = true;
		},
		tiskRozdilu() {
			this.tiskDialogUrl = 'Sestavy/Sklad/Inventura/GetSestavaRozdilu';
			this.visibleTiskDialog = true;
		},
		tiskPrehledu() {
			this.tiskDialogUrl = 'Sestavy/Sklad/Inventura/GetSeznamDilu';
			this.visibleTiskDialog = true;
		},
		tiskSeznamu() {
			this.tiskDialogUrl = 'Sestavy/Sklad/Inventura/GetSeznamDilu';
			this.visibleTiskDialog = true;
		},
	},
	watch: {
		async SkladOzn(newValue, oldValue) {
			try {
				this.startLoading();
				await dropdownListProvider.GetSkladMisto(this.SkladOzn!).then(({ data }) => {
					this.dropdownList.SklMistoIdList = data.sort((a: DropdownItem, b: DropdownItem) => a.Text.localeCompare(b.Text));
					if (oldValue) {
						this.SklMistoIdList = [];
						this.SkladMistoOd = null;
						this.SkladMistoOdText = null;
						this.SkladMistoDo = null;
						this.SkladMistoDoText = null;
					}
				});
			} finally {
				this.endLoading();
			}
		},
		SklMistoIdList: {
			deep: true,
			handler(SklMistoIdList) {
				if (SklMistoIdList && SklMistoIdList.length > 0 && SklMistoIdList.length === this.skladMistoItems.length) {
					this.SklMistoIdList = [];
				}
			},
		},
	},
});
